import { mapDispatchButtonGroup } from 'reg_redesign/redux/connectFunctions';
import ButtonGroup from '@opploans/button-group-component/ButtonGroup';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import IronChecking from 'images/IronCheckingIcon.svg';
import IronSaving from 'images/IronSavingIcon.svg';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';
import React from 'react';
import SkyChecking from 'images/SkyCheckingIcon.svg';
import SkySaving from 'images/SkySavingIcon.svg';

const additionalButtonStyle = {
  height: '10rem'
};

const buttonHeaderStyle = {
  fontSize: '16px'
};

export default {
  defaultNextPage: 'page-11',
  content: [
    configureProgressBar(65),
    configureTitle('Where is your income deposited?'),
    {
      component: ButtonGroup,
      name: 'accountType',
      dispatchOverride: mapDispatchButtonGroup,
      props: {
        id: 'accountType',
        direction: 'row',
        additionalButtonStyle,
        options: [
          {
            displayValue: 'Checking',
            id: 'accountTypeChecking',
            value: 'checking',
            unselectedChildren: (
              <div>
                <IronChecking />
                <p css={buttonHeaderStyle}>Checking</p>
              </div>
            ),
            selectedChildren: (
              <div>
                <SkyChecking />
                <p css={[buttonHeaderStyle, { fontWeight: 700 }]}>Checking</p>
              </div>
            )
          },
          {
            displayValue: 'Savings',
            id: 'accountTypeSavings',
            value: 'savings',
            unselectedChildren: (
              <div>
                <IronSaving />
                <p css={buttonHeaderStyle}>Savings</p>
              </div>
            ),
            selectedChildren: (
              <div>
                <SkySaving />
                <p css={[buttonHeaderStyle, { fontWeight: 700 }]}>Savings</p>
              </div>
            )
          }
        ]
      }
    },
    nextButtonConfig('page-10')
  ]
};
